import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Router } from '@angular/router';
import { SnackBarComponent } from 'dhwani-material-library';

@Component({
  selector: 'app-global-navigation-handler',
  templateUrl: './global-navigation-handler.component.html',
  styleUrls: ['./global-navigation-handler.component.css']
})
export class GlobalNavigationHandlerComponent implements OnInit {

  @Input() projectName: any;
  @Input() formName: any;
  @Input() suffix: any;
  @Input() specificPath: any;
  @Output() backNavigation = new EventEmitter<any>();
  @Input() isSharable:boolean = false;
  isContent: boolean = false;
  @Input() isReportType: boolean = false;
  @Output() reportChange = new EventEmitter<any>();
  navTypeTitle: string = 'Folder Structure';
  constructor(public router:Router,
    public snackBar: MatSnackBar,
    ) { }

  ngOnInit() {
  }

  isIframe(){
    return sessionStorage.getItem('isShared')
  }

  handleBackProject() {
    if (this.specificPath) {
      this.backNavigation.emit(this.specificPath);
    } else {
      this.backNavigation.emit('');
    }
  }
  getSharedLink(){
    let url = window.location.origin+'/#'+this.router.url;
    let token = sessionStorage.getItem('token');
    let projectId = sessionStorage.getItem('projectId');
    let orgId = sessionStorage.getItem('organisationId')
    url = `${url}?isApp=1&sharedProjectId=${projectId}&sharedOrgId=${orgId}&token=${token}`;
    this.copyText(url)
  }

  copyText(val) {
    let selBox = document.createElement('textarea');
    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val;
    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();
    document.execCommand('copy');
    document.body.removeChild(selBox);
    this.openSnackBar(['Shared Link Copied...'], 3000);
}
openSnackBar(data: string[], duration) {
  this.snackBar.openFromComponent(SnackBarComponent, { data, duration });
}

toggleNavType(value){
  this.reportChange.emit(value)
}
}
